import React, { useEffect, useState } from 'react'
import CustomModal from '../CustomModal/CustomModal';
import useCorsi from '../../hooks/useCorsi';
import CustomSlider from '../CustomSlider/CustomSlider';
import { ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { v4 as uuidv4 } from "uuid";

const RequirementsCourse = ({formDataDocument, setFormDataDocument, setDeleteDocumentiList}) => {
  const {addDocumentCorsi, modalStateCorsi, loadingStateCorsi, setModalStateCorsi} = useCorsi();
  const [isRequired, setIsRequired] = useState(false);


  // useEffect(() => {
  //   console.log(formDataDocument)
  // }, [formDataDocument])

  const [formData, setFormData] = useState({
    tipo: "",
    descrizione: "",
    obbligatorio: false,
    isNew: true,
  })

  const openModalAddDocument = () => {
    setModalStateCorsi(state => ({ ...state, showModalAddDocumentCorsi: true }));
  }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value
        });
    };


    const handleCheckboxChange = (isChecked) => {
        setIsRequired(isChecked);
    };

   const handleCloseModal = () => {
    setModalStateCorsi(state => ({ 
       ...state,
       showModalAddDocumentCorsi: false, 
       showModalDeleteDocumentCorsi: false, 
      }));
  }  

  const onAddDocumentInLocal = () => {
    const required = (isRequired) ? "1" : "0";
    const uniqueId = uuidv4();
    formData.id_documento = uniqueId; 
    formData.obbligatorio = required;

    setFormDataDocument(prev => [...prev, formData]); 
    setFormData({ tipo: "", descrizione: "", obbligatorio: "0", isNew: true }); 
    handleCloseModal();
    setIsRequired(false)
  };

  const onDeleteDocumentInLocal = (id) => {
    const document = formDataDocument.find(document => document?.id_documento == id)
    if(!document?.isNew) {
        setDeleteDocumentiList(prev => [...prev, document])
    }

    const updateFormData = formDataDocument.filter(document => document?.id_documento != id);
    setFormDataDocument(updateFormData);
  };


    const renderDocumentFields = () => (
        <div>
          <span className='small text-muted d-block'><b>Tipo</b></span>
        <input 
            type="text" 
            className='form-control mb-3'
            name="tipo" 
            value={formData.tipo} 
            onChange={handleChange} 
            placeholder="Tipo"
        />
         <span className='small text-muted d-block'><b>Descrizione</b></span>
        <textarea 
            name="descrizione" 
            className='form-control mb-3'
            value={formData.descrizione} 
            onChange={handleChange} 
            placeholder="Descrizione"
        />
          <span className='small text-muted d-block'><b>Obbligatorio</b></span>
           <CustomSlider
              handleSliderChange={handleCheckboxChange}
              labelText="obbligatorio?"
              />
        </div>
    );

  return (
    <>
    <div className='mb-2'>
        <span className='me-2'>Vuoi aggiungere dei requisiti? </span>
        <button className='btn btn-primary btn-sm' onClick={openModalAddDocument}>Aggiungi</button>
    </div>
        <ListGroup>
    {
        formDataDocument?.map((el) => (
            <ListGroup.Item variant='secondary' className='py-2 my-1' style={{maxWidth: "500px", cursor: "default"}} as="li" key={el?.id_documento}>
                <>
                <div className='d-flex justify-content-between'>
                <div>
                    <span className='me-2'>
            
                 {  (el?.obbligatorio == "1") ? 
                    <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-disable">Obbligatorio</Tooltip>}
                  >
                    <i role='button' className="bi bi-exclamation-circle-fill text-danger"></i> 
                </OverlayTrigger>
                   : 
                   <OverlayTrigger
                   placement="top"
                   overlay={<Tooltip id="tooltip-disable">Facoltativo</Tooltip>}
                 >
                   <i role='button' className="bi bi-exclamation-circle-fill text-success"></i>
                
               </OverlayTrigger>}
                    </span>
                    <span>
                    {el?.tipo} 
                    </span>
                </div>
                <span>
                <i onClick={() => onDeleteDocumentInLocal(el?.id_documento)} role='button' className="bi bi-x-lg text-dark"></i>
                </span>
                </div>
                <span className='text-muted small'>
                {el?.descrizione} 
                </span>
                </>
           </ListGroup.Item>
        ))
    }
        </ListGroup>
    <CustomModal
          show={modalStateCorsi.showModalAddDocumentCorsi}
          onHide={handleCloseModal}
          headerText="Aggiungi requisito"
          size={"md"}
          btnText={"Aggiungi"}
          body={renderDocumentFields()} 
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onAddDocumentInLocal} 
        />
    </>
  )
}

export default RequirementsCourse